<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Hoje
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Hoje</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mês</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 Dias</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          locale="pt-BR"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title
                >{{ selectedEvent.name }}
                <v-icon v-if="selectedEvent.confirmed" color="green"
                  >mdi-verified-outlined</v-icon
                ></v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-menu
                offset-y
                v-if="module === 'professor'"
                :disabled="selectedEvent.color === 'red'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-on="on" v-bind="attrs">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    ><v-btn plain text @click="setupAulas(selectedEvent)">
                      Opções da aula
                    </v-btn></v-list-item
                  >
                </v-list>
              </v-menu>
              <v-menu
                offset-y
                v-if="module === 'aluno'"
                :disabled="selectedEvent.color === 'red'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-on="on" v-bind="attrs">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    ><v-btn plain text @click="modalAdiarAluno(selectedEvent)">
                      Solicitar alteração
                    </v-btn></v-list-item
                  >
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-row class="mt-2">
                <span v-html="selectedEvent.details"></span>
              </v-row>
              <v-row class="mt-4">
                <strong class="top"
                  >Código da turma: {{ selectedEvent.code }}</strong
                >
              </v-row>
              <v-row class="mt-4">
                <strong class="top"
                  >Nível: {{ showLevel(selectedEvent.level) }}</strong
                >
              </v-row>
              <v-row class="mt-4">
                <strong class="top">Participantes: </strong>
              </v-row>
              <v-row class="mt-4">
                <v-chip
                  small
                  v-for="(student, index) in selectedEvent.students"
                  :key="index"
                  >{{ student.full_name }}</v-chip
                >
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" @click="selectedOpen = false">
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>

              <v-btn text color="primary" v-if="module === 'aluno'"
                ><a :href="selectedEvent.link" target="_blank"
                  >Acessar aula</a
                ></v-btn
              >
              <v-btn
                plain
                text
                @click="setupAulas(selectedEvent)"
                v-if="module === 'professor'"
              >
                Opções da aula
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
    <classEditDialog
      ref="dialog"
      :item="focused"
      @confirm="confirmClass"
      @adiar="modalAdiar"
    />
    <adiarAulaDialog ref="adiar" :item="adiando" @confirm="adiarAula" />
    <adiarAulaAlunoDialog
      ref="adiarAluno"
      :item="adiando"
      @confirm="adiarAulaAluno"
    />
  </v-row>
</template>
<script>
import store from "@/store";
import partnerApi from "@/shared/pitchPartnerApi";
import classEditDialog from "./classEditDialog.vue";
import adiarAulaDialog from "./adiarAulaDialog.vue";
import adiarAulaAlunoDialog from "./adiarAulaAlunoDialog.vue";
export default {
  name: "AppCalendar",
  components: { classEditDialog, adiarAulaDialog, adiarAulaAlunoDialog },
  props: {
    items: Array,
  },
  computed: {},
  data: () => ({
    focused: {},
    adiando: {},
    module: store.getters.module,
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [], // Inicialmente vazio,
    englishLevels: [
      {
        text: "Beginner 1",
        value: 0,
      },
      {
        text: "Beginner 2",
        value: 1,
      },
      {
        text: "Essential 1",
        value: 2,
      },
      {
        text: "Essential 2",
        value: 3,
      },
      {
        text: "Pre Intermediate 1",
        value: 4,
      },
      {
        text: "Pre Intermediate 2",
        value: 5,
      },
      {
        text: "Intermediate 1",
        value: 6,
      },
      {
        text: "Intermediate 2",
        value: 7,
      },
      {
        text: "Upper 1",
        value: 8,
      },
      {
        text: "Upper 2",
        value: 9,
      },
      {
        text: "Advanced 1",
        value: 10,
      },
      {
        text: "Advanced 2",
        value: 11,
      },
    ],
  }),
  mounted() {
    this.events = this.items.map((item) => ({
      id: item.id,
      name: `${item.name}`,
      details: `<strong class="top">${item.description}</strong> <br/> <strong>Acesse pelo link: </strong> <a href="${item.link}" target="_blank">${item.link}</a> <br/>`,
      start: new Date(item.start),
      end: new Date(item.end),
      color: item.color,
      timed: true,
      link: item.link,
      confirmed: false,
      level: item.level,
      code: item.code,
      students: item.students,
      classId: item.classId,
    }));
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    setupAulas(item) {
      this.focused = item;
      this.$refs.dialog.open();
    },
    confirmClass(item) {
      partnerApi.confirmClass(item.id).then(() => {
        this.$root.$emit("display-alert", {
          text: "Aula confirmada com sucesso!",
          type: 0,
        });
      });
      this.$refs.dialog.close();
      this.$emit("reload");
    },
    modalAdiar(item) {
      this.$refs.dialog.close();
      this.adiando = item;
      this.$refs.adiar.open();
    },
    modalAdiarAluno(item) {
      this.adiando = item;
      this.$refs.adiarAluno.open();
    },
    adiarAula(data) {
      this.$refs.adiar.close();
      this.$emit("adiar", data);
    },
    adiarAulaAluno(data) {
      this.$refs.adiarAluno.close();
      this.$emit("adiar", data);
    },
    showLevel(level) {
      if (level)
        return this.englishLevels.filter((l) => l.value === +level)[0].text;
    },
  },
};
</script>

<style scoped>
.top {
  font-size: 1rem;
}
</style>
